export const en = {
  translation: {
    emptyState: {
      noStudents: "No Students Found.",
    },
    studentCarousel: {
      admitted: "Admitted",
      noMajors: "No majors added",
      noStudents: "No recently contacted students",
      seeMore: "See more students!",
      viewAll: "View all",
      recentlyJoined: "Recently Joined",
      recentlyReached: "Recently Reached",
      recentParticipants: "Recent Participants",
      noLocation: "No location added",
      genericError: "Could not load student carousel.",
    },
    carousel: {
      previousSlide: "Previous slide",
      nextSlide: "Next slide",
    },
    gamesLiveEvents: {
      communityToolsOverview: {
        tabs: {
          gamesLiveEvents: {
            title: "Upcoming",
            tabName: "Games & Live Events",
            subtitle: "A quick summary of upcoming games & live events",
            emptyState: "You don't have any upcoming games or live events",
          },
        },
        scheduleNewButton: "Schedule a new event",
        columns: {
          eventName: "Event Name",
          eventType: "Event Type",
          startTime: "Start Time",
          audience: "Audience",
          chatChannel: "Chat Channel",
          edit: "Edit",
        },
        actions: {
          details: "Details",
          delete: "Delete",
          exportCsv: "Export to CSV",
          share: "Share",
          shareToast: {
            success:
              "Copied! A shareable link has been copied to your clipboard.",
          },
        },
        filters: {
          eventType: "Event Type",
          audience: "Audience",
          chatChannel: "Chat Channel",
        },
      },
    },
    bulkMessaging: {
      titleBulkMessage: "Bulk Message",
      dashboard: "BulkMessaging dashboard",
      recentlyContacted: "Recently Messaged",
      createBulkMessage: "Create bulk message",
      fromLastCycle: "from last cycle",
      firstTimeMessageRecipients: "First-Time Recipients",
      filters: {
        oneTimeSend: "One Time Send",
        campaign: "Campaign",
      },
      bentos: {
        totalCampaigns: "Total Campaigns",
        totalCampaignsToolTip:
          "Number of bulk message campaigns sent & scheduled by community officials since August",
        totalMessages: "Total Messages",
        totalMessagesToolTip:
          "Number of individual direct messages sent & scheduled by community officials since August",
        error: {
          loadingError: "Error loading data",
        },
      },
      communityToolsOverview: {
        tabs: {
          bulkMessages: {
            title: "Active & Scheduled",
            tabName: "Bulk Messages",
            subtitle:
              "A quick summary of your active & scheduled bulk messages",
            emptyState: "You don't have any active or scheduled bulk messages",
          },
        },
        createNewButton: "Create new bulk message",
        status: {
          active: "Active",
          scheduled: "Scheduled",
        },
        columns: {
          name: "Name",
          status: "Status",
          createdAt: "Created at",
          startDate: "Start date",
          createdBy: "Created by",
          details: "Details",
        },
        actions: {
          edit: "Edit",
          stopCampaign: "Stop",
          deleteMessage: "Delete",
          exportCsv: "Export to CSV",
        },
        filters: {
          status: "Status",
          createdBy: "Created by",
        },
        bentos: {
          studentInteractions: "Student Interactions",
          studentInteractionsToolTip:
            "Total number of student engagements with campaigns created by your community officials since August (includes bulk messages, live events, games, competitor match, dynamic action buttons & feed posts)",
          totalCampaignsSent: "Total Campaigns",
          totalCampaignsSentToolTip:
            "Total number of campaigns created by community officials since August (includes bulk messages, live events, games, competitor match, dynamic action buttons & feed posts)",
          error: {
            loadingError: "Error loading data",
          },
        },
      },
      table: {
        assignedCounselor: "Assigned Counselor",
        active: "Active",
        draft: "Drafts",
        scheduled: "Scheduled",
        completed: "Completed",
        name: "Name",
        campaignType: "Campaign Type",
        senderType: "Sender Type",
        sentFrom: "Sent From",
        sentTo: "Audience",
        audience: "Audience",
        startSendingAt: "Start Date",
        stopSendingAt: "End Date",
        campaign: "Campaign",
        tableActions: "Details",
        editActions: "Edit",
        oneTimeSend: "One time send",
        sure: "Are you sure?",
        cancel: "Cancel",
        yes: "Yes",
        copySure:
          "Are you sure you want to stop this bulk message? You cannot restart a campaign once stopped.",
        stop: {
          name: "Stop",
          title: "Are you sure?",
          description:
            "Are you sure you want to stop this bulk message? You cannot restart a campaign once stopped.",
          success: "Successfully stopped bulk message",
          error: "Error stopping bulk message",
        },
        delete: {
          name: "Delete",
          title: "Delete Bulk Message?",
          description: "Are you sure you want to delete this bulk message?",
          success: "Successfully deleted bulk message",
          error: "Error deleting bulk message",
        },
        emptyStates: {
          active: "You don't have any active campaigns at the moment",
          draft: "You don't have any drafted campaigns at the moment",
          scheduled: "You don't have any scheduled campaigns at the moment",
          completed: "You don't have any completed campaigns at the moment",
          error:
            "Whoops! There was an error loading this page. Please refresh and try again. Contact support@zeemee.com if the problem continues.",
        },
        createNewBulkMessage: "Create new bulk message",
        descriptions: {
          active: "Live bulk message campaigns",
          draft: "Drafted bulk message campaigns",
          scheduled: "Upcoming bulk message campaigns",
          completed: "Completed bulk message campaigns",
        },
        actions: {
          exportCsv: "Export to CSV",
          exportImage: "Export as image",
          share: "Share",
        },
      },
      title: "Send Bulk Message",
      editTitle: "Edit Bulk Message",
      basicInformation: {
        title: "Audience Details",
        subtitle: "Fill out the basic information below to get started",
        typeSelectionHeader: "How do you want to find students?",
        studentFilters: {
          title: "Student Filters",
          description: "Find students based on specific criteria",
          loadingStudents: "Loading students...",
          atLeastOneSelected: "At least one student filter must be used",
        },
        csvImport: {
          title: "Import from CSV",
          description: "Upload a list of students via CSV file",
          uploadStudents: "Upload students from CSV",
          removeStudents: "Remove Students",
          missingIds:
            "<0>Reminder</0>: You must upload a CSV of existing ZeeMee users",
          dragAndDrop: "Drag and drop your CSV file here",
          selectAFile: "Or select a file from your computer",
          seeInstructions: "See instructions",
          instructionsHeader: "CSV upload instructions",
          instructions:
            "The CSV file must contain only one column of data named ID. That column should contain IDs for users in your community.",
          exampleFile: "See an example CSV file",
          contact:
            "Contact your Director of Partner Success or email <1>support@zeemee.com</1> for additional help.",
          uploading: "Uploading CSV...",
          foundAll: "Found all students in csv",
          studentsNotFound: "<0>{{count}}</0> Students Not Found",
          tryAgain: "Try again",
          missingDialogTitle: "Some Student IDs Not Found",
          missingDialogDescription:
            "These IDs did not match students in your community:",
          badCsvFile: {
            title: "Bad CSV file uploaded",
            description:
              "Please try uploading again or reach out to your Partner Success Director.",
          },
          failedToUpload: {
            title: "Oops something went wrong!",
            description:
              "Please try uploading again or reach out to your Partner Success Director. Please ensure your file consists of only one column labeled 'ID'",
          },
        },
        riseAction: {
          previewDesc: "Students from your Strategy Board Action",
        },
        inputs: {
          campaign: {
            label: "Campaign Name",
            placeholder: "Name this campaign for internal tracking",
            error: "Campaign name is required",
          },
          firstTimeMessageRecipients: {
            label: "Send to first time DM recipients only?",
            placeholderYes:
              "Send only to students who have not received a bulk message",
            placeholderNo: "Send to all selected students",
          },
        },
        nameRequiredError: "Your bulk message must have a name.",
      },
      composeMessage: {
        title: "Compose your message",
        subtitle: "Fill out what you want to send to students",
        placeholder: "This is where the message composition form would go...",
        editMessage: "Edit message",
        typeMessage: "Type your message here",
        addLink: "Add link",
        addName: "Add Name",
        addStudentName: "Add student's name",
        addSenderName: "Add sender's name",
        textPlaceholder: "Text",
        linkPlaceholder: "Link",
        linkTextPlaceholder: "Text for link",
        apply: "Apply",
        cancel: "Cancel",
        deleteElement: "Delete element",
        dragToReorder: "Drag to reorder",
        dropImagesHere: "Drop images here or click to browse",
        imageFormats: "Supports: JPG, PNG, GIF, WebP (max 10MB)",
        selectImage: "Select an image",
        addImageButton: "Add Image",
        noImagesSelected: "No images selected",
        bold: "Bold",
        italic: "Italic",
        addText: "Add text",
        addImage: "Add image",
        senderAvatarAlt: "Not Selected",
        deleteMessage: "Delete message",
        dragHandle: "Drag handle",
        removeImage: "REMOVE",
        uploadedImageAlt: "Uploaded image {{number}}",
        messageAttachmentAlt: "Message attachment {{number}}",
        uploadPreviewAlt: "Upload preview",
        phoneTime: "9:41",
        defaultSenderName: "Not Selected",
        boldTooltip: "Bold (Cmd+B)",
        italicTooltip: "Italic (Cmd+I)",
        emptyMessage: "Tap to edit message",
        editImages: "Edit Images",
        tapToEdit: "Tap to edit",
        tapToAddImages: "Tap to add images",
        activeNow: "Active now",
        done: "Done",
        send: "Send",
        uploadImage: "Upload Image",
        supportedFormats: "PNG, JPG, GIF up to 10MB",
        oneTimeSend: {
          title: "One time send",
          subtitle: "Immediately send to students who fit your criteria",
          whenToSend: "When to send?",
          sendNow: "Send now",
          sendLater: "Send later",
        },
        sendCampaign: {
          title: "Send campaign",
          subtitle: "Send to students who fit your criteria on a future date",
        },
        inputs: {
          sendFrom: {
            name: "Send from",
            placeholder: "Select message sender",
            assignedCounselor: "Student's Assigned Counselor",
            error: "A sender must be chosen",
          },
          sendOptions: {
            name: "Send options",
            error: "You must complete send options selections",
          },
          date: {
            placeholder: "Pick a date",
            scheduleStartDate: "Schedule Send Date",
            scheduleEndDate: "Schedule End Date",
            requiredError: "Date and time must be selected",
            startBeforeEndError:
              "Schedule Send Date must be before Schedule End Date",
          },
          messageParts: {
            error: "You must add at least one message",
          },
        },
        assignedCounselor: "Assigned Counselor",
        unknownSender: "Unknown Sender",
      },
      review: {
        title: "Review",
        subtitle: "Review your campaign message and see how things look",
        almostDone:
          "You're almost done! This campaign will send a message to <1>{{count}}</1> students.",
        edit: "Edit",
        formerOffical: "Former official",
        sendNow: "Send now",
        sendLater: "Send on {{sendDate}}",
        startCampaign: "Send from {{startDate}} until {{endDate}}",
        formerOfficial: "Former Official",
        sendFrom: "Sent From",
        sendOptions: "Timeframe",
        missingTimeZone: "No time zone set",
        riseActionRecipients:
          "Sending to students from your strategy board action.",
        messagePreview: {
          title: "Message Preview",
          description: "Review the text and media 👉",
        },
        timingError:
          "The scheduled date and time must be in the future. Please go back and pick a future date.",
        messageError:
          "There must be at least one message sent. Please go back and add a message.",
        studentCountError:
          "Messages must be sent to at least one student. Please go back and pick filters that will send to students",
      },
      navigation: {
        areYouSure: "Are you sure?",
        youWillLoseYourChanges:
          "You will lose all changes made. Did you want to discard changes?",
        submitError: {
          title: "Oops something went wrong!",
          description:
            "Please try again or reach out to your Partner Success Director",
        },
        saveDraft: "This will change your scheduled bulk message to a draft. ",
        draftSuccess: {
          title: "Draft Successfully Saved!",
          description: "Check your bulk message dashboard",
        },
      },
      studentsList: {
        title: "Current Students",
        description: "All your students from your community",
      },
      studentBar: {
        didNotFindAny: "We didn't find any students, please try again...",
        extraStudents: "others",
        foundStudents: "Found <1>{{count}}</1> Students",
      },
      details: {
        title: "Bulk Message Details",
        campaignDetails: "Campaign Details",
        placeholder: "This is where the bulk message details will be...",
        noDataAvailable: "No bulk message data available",
        foundStudentsCompleted:
          "This message was sent to <1>{{count}}</1> students",
        foundStudentsActive:
          "This message has been sent to <1>{{count}}</1> students",
      },
      congrats: {
        sucessfullySent: "You've succesfully sent a bulk message!",
        description:
          "It may take a few minutes for all students to receive your message. You'll be contacted by email if there are any issues.",
        done: "OK, I'm done",
        studentCount: "{{count}} students",
      },
      timeZoneError:
        "Your community needs a timezone to send a bulk message! Contact support@zeemee.com to fix this.",
    },
    studentsList: {
      title: "Student List",
      listTitle: "Matching Students",
      backToContext: {
        bulkMessages: "Back to Bulk Messages",
        funnelChart: "Back to Zeemee Funnel",
        feedPosts: "Back to Feed Posts",
        communityTools: "Back to Community Tools",
        gamesAndLiveEvents: "Back to Games and Live Events",
      },
      contextDescription: {
        communityTools:
          "Displaying {{totalCount}} students reached by your community",
        feedPosts:
          "Displaying {{totalCount}} students who've viewed a feed post",
        gamesAndLiveEvents: "Displaying {{totalCount}} event participants",
        bulkMessages:
          "Displaying {{totalCount}} students who've received a bulk message",
      },
    },
    filteredStudents: {
      description: "Displaying {{totalCount}} students based on filters",
    },
    filters: {
      topFilters: "Top Filters",
      sidebarTitle: "Filters",
      closeSidebar: "Close Filter Sidebar",
      searchPlaceholder: "Search for a filter",
      collapseFilterGroups: "Collapse Filter Groups",
      apply: "Apply",
      clear: "Clear All",
      appData: "ZeeMee Data",
      studentDetails: "Student Details",
      locationSection: "Location",
      crmAndApplicationData: "CRM & Application Data",
      assignedCounselors: "Assigned Counselor",
      selectCounselors: "Select Counselors",
      commitIndex: "Commit Index",
      mostEngaged: "Most Engaged Students",
      selectMostEngaged: "Select Engagement Level",
      predictiveModels: "Predictive Models",
      applyIndex: "Apply Index",
      selectApplyIndex: "Select Apply Index",
      meltIndex: "Melt Index",
      selectMeltIndex: "Select Melt Index",
      yieldIndex: "Yield Index",
      selectYieldIndex: "Select Yield Index",
      riseCommitIndex: "Commit Index",
      selectRiseCommitIndex: "Select Commit Index",
      selectCommitIndex: "Select commit Index",
      upTrending: "Up-Trending Scores",
      selectModel: "Select Model",
      downTrending: "Down-Trending Scores",
      interests: "Interests",
      selectInterests: "Select Interests",
      major: "Major",
      majors: "Majors",
      selectMajor: "Select Major",
      goingStatus: "Going Status",
      goingElsewhere: "Going Elsewhere",
      moreActiveElsewhere: "More Active Elsewhere",
      attendedALiveEvent: "Attended a Live Event",
      joinDate: "Join Date",
      joinType: "Join Type",
      joinState: "Join State",
      funnelState: "Funnel State",
      funnelStates: "Funnel States",
      selectFunnelState: "Select one or more funnel states",
      cohortYear: "Cohort Year",
      selectCohortYear: "Select Cohort Year",
      studentType: "Student Type",
      selectStudentType: "Select student type",
      gender: "Gender",
      country: "Country",
      state: "State",
      selectState: "Select State",
      zipCode: "Zip Code",
      selectZipCode: "Select Zip Code",
      directAdmission: "Direct Admission",
      deposited: "Deposited",
      firstGeneration: "First Generation",
      studentAthlete: "Student Athlete",
      campusVisit: "Campus Visit",
      commitDate: "Commit Date",
      leadSource: "Lead Source",
      selectLeadSource: "Select Lead Source",
      entryTerm: "Entry Term",
      selectEntryTerm: "Select Entry Term",
      fafsaCompletionStatus: "Completed FAFSA",
      ceebCode: "CEEB Code",
      selectCeebCode: "Enter CEEB code(s)",
      scrollForMore: "Scroll for more",
      location: "Location",
      selectLocation: "Select US states or international students",
      studentSource: "Student Source",
      selectStudentSource: "Select one or more sources",
      startTerm: "Start Term",
      selectStartTerm: "Select start terms",
      engagementPercentile: "Engagement Percentile",
      commitScoreTrend: "Commit Score Trend",
      upTrendingScores: "Up Trending Scores",
      downTrendingScores: "Down Trending Scores",
      commitScoreTrends: "Commit Score Trends",
      selectCommitScoreTrends: "Select Commit Score Trends",
      fieldOptions: {
        NULL: "",
        YES: "Yes",
        NO: "No",
        FALL: "Fall",
        SPRING: "Spring",
        SUMMER: "Summer",
        FIRST_YEAR: "First-Year",
        TRANSFER: "Transfer",
        HIGH: "High",
        MEDIUM_HIGH: "Medium High",
        LOW: "Low",
        MEDIUM_LOW: "Medium Low",
        MEDIUM: "Medium",
        ADMITTED: "Admitted",
        APPLIED: "Applied",
        APPLY: "Apply",
        COMMIT: "Commit",
        MELT: "Melt",
        YIELD: "Yield",
        PRE_INQUIRED: "Pre-Inquired",
        ACCEPTANCE_DECLINED: "Acceptance Declined",
        ACCEPTED: "Accepted",
        APP_COMPLETE: "Application Complete",
        APPLICATION_CANCELED: "Application Canceled",
        APPLICATION_COMPLETE: "Application Complete",
        APPLICATION_COMPLETE_WITHDRAWN: "Application Complete Withdrawn",
        APPLICATION_STARTED: "Application Started",
        APPLICATION_STARTED_CANCELED: "Application Started Canceled",
        COMMITMENT_WITHDRAWN: "Commitment Withdrawn",
        DATE_OF_INITIAL_CONTACT_MISSING: "Date of Initial Contact Missing",
        DEFERRED: "Deferred",
        DEFERRED_WITHDRAWN: "Deferred Withdrawn",
        DENIED: "Denied",
        ENROLLED: "Enrolled",
        INQUIRED_DROPPED: "Inquired Dropped",
        LEAD: "Lead",
        LEAD_DROPPED: "Lead Dropped",
        WAITLISTED: "Waitlisted",
        WAITLISTED_WITHDRAWN: "Waitlisted Withdrawn",
        COMMITTED: "Committed",
        INQUIRED: "Inquired",
        GOING: "Going",
        NOTGOING: "Not Going",
        UNDECIDED: "Undecided",
        BRANCH: "Invited",
        COMPETITOR_MATCH: "Competitor Match",
        CSV: "CSV",
        ORGANIC: "Organic",
        FEMALE: "Female",
        MALE: "Male",
        OTHER: "Other",
        DOMESTIC: "Domestic",
        INTERNATIONAL: "International",
        NON_FILER: "Non-filer",
        AL: "Alabama",
        NE: "Nebraska",
        AK: "Alaska",
        AS: "American Samoa",
        NV: "Nevada",
        AZ: "Arizona",
        NH: "New Hampshire",
        AR: "Arkansas",
        NJ: "New Jersey",
        CA: "California",
        NM: "New Mexico",
        CO: "Colorado",
        NY: "New York",
        CT: "Connecticut",
        NC: "North Carolina",
        DE: "Delaware",
        ND: "North Dakota",
        DC: "District of Columbia",
        OH: "Ohio",
        FL: "Florida",
        OK: "Oklahoma",
        GA: "Georgia",
        OR: "Oregon",
        HI: "Hawaii",
        PA: "Pennsylvania",
        ID: "Idaho",
        PR: "Puerto Rico",
        IL: "Illinois",
        RI: "Rhode Island",
        IN: "Indiana",
        SC: "South Carolina",
        IA: "Iowa",
        SD: "South Dakota",
        KS: "Kansas",
        TN: "Tennessee",
        KY: "Kentucky",
        TX: "Texas",
        LA: "Louisiana",
        UT: "Utah",
        ME: "Maine",
        VT: "Vermont",
        MD: "Maryland",
        VA: "Virginia",
        MA: "Massachusetts",
        VI: "Virgin Islands",
        MI: "Michigan",
        WA: "Washington",
        MN: "Minnesota",
        WV: "West Virginia",
        MS: "Mississippi",
        WI: "Wisconsin",
        MO: "Missouri",
        WY: "Wyoming",
        MT: "Montana",
        GU: "Guam",
        MP: "Northern Mariana Islands",
        ALL_US_STUDENTS: "All US students",
        ALL_INTERNATIONAL_STUDENTS: "All international students",
        COMMUNITY_MATCH: "Community Match",
        TOP_1_PERCENT: "Top 1%",
        TOP_5_PERCENT: "Top 5%",
        TOP_10_PERCENT: "Top 10%",
        TOP_25_PERCENT: "Top 25%",
        TOP_50_PERCENT: "Top 50%",
        UPTRENDING: "Up-Trending",
        DOWNTRENDING: "Down-Trending",
      },
      pills: {
        plusMore: "{{plusCount}} more",
        noFiltersSelected: "No filters selected",
        dateRange: "{{from}} to {{to}}",
        studentType: {
          FIRST_YEAR: "First-year students",
          TRANSFER: "Transfer students",
        },
        goingElsewhere: {
          YES: "Going elsewhere",
          NO: "Not going elsewhere",
        },
        attendedALiveEvent: {
          YES: "Attended a live event",
          NO: "Has not attended a live event",
        },
        country: {
          DOMESTIC: "Domestic students",
          INTERNATIONAL: "International students",
        },
        directAdmission: {
          YES: "Direct admission",
          NO: "Not direct admission",
        },
        deposited: {
          YES: "Deposited",
          NO: "Has not deposited",
        },
        firstGeneration: {
          YES: "First generation",
          NO: "Not first generation",
        },
        studentAthlete: {
          YES: "Student athletes",
          NO: "Not student athletes",
        },
        campusVisit: {
          YES: "Has visited campus",
          NO: "Has not visited campus",
        },
      },
    },
    login: {
      back: "Back",
      forgot: "Forgot Password?",
      email: "Email address",
      password: "Password",
      signIn: "Sign In",
      next: "Next",
      match: "Passwords must match",
      change: "Change Password",
      new: "New Password",
      confirm: "Confirm new password",
      update: "Update Password",
      instructions: "We'll email you instructions to reset your password",
      send: "Send Instructions",
      insights: "Insights",
      signInHeading: "Sign in",
      subtitle:
        "Log in to your dashboard and stay connected with your students.",
      emailLabel: "Email",
      passwordLabel: "Password",
      keepSignedIn: "Keep me signed in",
      forgotPassword: "Forgot password?",
      loading: "Loading...",
      noAccount: "Don't have an account?",
      contactUs: "Contact us",
      otpSubtitle: "Two-Factor Authentication",
      otpLabel: "Enter your code",
      otpInstructions: "We sent a code to your email.",
      otpError: "Your two factor authentication code is invalid.",
      hidePassword: "Hide password",
      showPassword: "Show password",
    },
    home: {
      title: "Partner dashboard homepage",
      welcome: "Hi, {{name}}!",
      featuredStudentCardTitle: "Featured Student of Browser Session",
      noFeaturedStudents: "No featured students at the moment.",
      mostEngagedStudents: {
        title: "Most Talkative Students",
        subtitle: "Top 100 students chatting in public channels since August 1",
      },
      studentCarousel: {
        title: "New Students in Your Community",
      },
      communityGrowthChart: {
        title: "Community Growth",
        description: "Student adoption by cohort year",
      },
      overview: {
        title: "Overview",
        lastCycle: "last cycle",
        versusLastCycle: "versus {{pct}}% last cycle",
        vsZeroLastCycle: "vs. 0 last cycle",
        recentlyReached: "Students reached",
        dataCells: {
          title: "A quick look at your {{cohort}} cohort",
          communityMembers: "Community Members",
          communityMembersToolTip: "Students currently in your community",
          highIndexStudents: "High Index Students",
          highIndexStudentsToolTip:
            "Students in your community with a high commit index",
          inCommunityCommits: "In-Community Commits",
          inCommunityCommitsToolTip: "Committed students in your community",
          inCommunityYieldRate: "In-Community Yield Rate",
          inCommunityYieldRateToolTip:
            "Yield rate for students in your community (number of committed students on ZeeMee / number of admitted students on ZeeMee)",
          error: {
            loadingError: "Error loading data",
          },
        },
      },
    },
    global: {
      filters: "Filters",
      addFilter: "Add filter",
      loading: "Loading...",
      more: "More",
      close: "Close",
      cancel: "Cancel",
      error: "Error: {{message}}",
      previous: "Previous",
      next: "Next",
      of: "of",
      pages: "pages",
      pagination: "Pagination",
      viewOptions: "View options",
      filter: "Filter",
      descending: "Descending",
      ascending: "Ascending",
      noRows: "No Rows",
      noResults: "No results",
      upgrade: "UPGRADE",
      remove: "Remove",
      clear: "Clear",
      chooseADate: "Choose a date",
      chooseARange: "Choose a range",
      yes: "Yes",
      no: "No",
      all: "All",
      OK: "OK",
      update: "Update",
      save: "Save",
      socialMediaLinks: "Social Media Links",
      apply: "Apply",
      saveAsDraft: "Save as Draft",
      submit: "Submit",
      submitting: "Submitting...",
      discardChanges: "Discard changes",
      pageOfTotal: "{{page}} of {{totalPages}} pages",
      riseLogoAlt: "RISE Logo",
      shareLinks: {
        linkCopied: "Link copied!",
        linkError: "Error copying link, try again",
      },
      funnelStates: {
        admitted: "Admitted",
        applied: "Applied",
        acceptanceDeclined: "Acceptance Declined",
        accepted: "Accepted",
        applicationCanceled: "Application Canceled",
        applicationComplete: "Application Complete",
        applicationCompleteWithdrawn: "Application Complete Withdrawn",
        applicationStarted: "Application Started",
        applicationStartedCanceled: "Application Started Canceled",
        commitmentWithdrawn: "Commitment Withdrawn",
        deferred: "Deferred",
        deferredWithdrawn: "Deferred Withdrawn",
        denied: "Denied",
        enrolled: "Enrolled",
        inquiredDropped: "Inquired Dropped",
        lead: "Lead",
        leadDropped: "Lead Dropped",
        waitlisted: "Waitlisted",
        waitlistedWithdrawn: "Waitlisted Withdrawn",
        committed: "Committed",
        inquired: "Inquired",
        imageInvalidType:
          "Please upload a valid image file (JPEG, PNG, GIF, or WebP)",
        imageTooLarge: "Image size must be less than 5MB",
      },
      features: {
        automatedGames: "Automated Games",
        bulkMessaging: "Bulk Messaging",
        RISE: "RISE",
        RisePredictiveModels: "RISE Predictive Models",
        RiseStrategyBoard: "RISE Strategy Board",
      },
      unexpectedError: "An unexpected error occurred",
      generalError: {
        title: "Whoops!",
        message:
          "Something went wrong. Please reload the page and try again. <br>If you're still having issues, contact <supportLink>support@zeemee.com</supportLink>.",
      },
      fatalError: {
        title: "Whoops!",
        message:
          "Something went wrong. Please reload the page and try again. <br>If you're still having issues, contact <supportLink>support@zeemee.com</supportLink>.",
      },
      actions: {
        viewProfile: "View Profile",
        message: "Message",
      },
      exportToCSV: {
        menuTitle: "Export to CSV",
        success: "Successfully exported CSV",
        failure: "Failed to export to CSV",
      },
      share: "Share",
      controlKey: "Ctrl",
    },
    aria: {
      studentActive: "Student is active in the last 30 minutes",
      filter: "Filters",
      ascending: "Ascending",
      descending: "Descending",
      pages: "Pages",
      noRows: "No Rows",
      previous: "Previous",
      next: "Next",
      noResults: "No results",
      openMenu: "Open Menu",
    },
    nav: {
      title: "Insights",
      logout: "Log out",
      manageProfile: "My Profile",
      editProfile: "Profile",
      home: "Community Snapshot",
      overview: "Overview",
      data: "Analytics",
      funnel: "ZeeMee Funnel",
      adoption: "Adoption & Engagement",
      predictiveModels: "Predictive Models",
      students: "Student List",
      studentProfile: "Student Profile",
      communityTools: "Community Tools",
      chatGames: "Games & Live Events",
      eventDetails: "Event Details",
      bulkMessaging: "Bulk Messaging",
      peerMessaging: "Peer community messaging",
      competitorMatch: "Competitor match",
      dab: "Dynamic action button",
      feedPosts: "Feed Posts",
      communityManagement: "Community Management",
      channelManagement: "Manage channels",
      channelRequest: "Channel Request",
      teamManagement: "Team Management",
      updateSchool: "Update School Profile",
      dataManagement: "Data Management",
      file: "File Storage",
      resources: "Resources",
      settings: "Settings",
      manageAccounts: "Manage Accounts",
      notificationSettings: "Notification Settings",
      chat: "Chat",
      alerts: "Alerts",
      toggleMenu: "Toggle Menu",
      userMenu: "User Menu",
      zeeMeeLogo: "ZeeMee Logo",
      organization: "Organization",
      organizationMenu: "Organization Menu",
      main: "Main",
      user: "User",
      sidebar: "Sidebar",
      displaySidebar: "Displays the mobile sidebar.",
      toggleSidebar: "Toggle Sidebar",
      components: "Components",
      schools: "Schools",
      rise: "RISE",
      strategy: "Today's Strategy Board",
      impact: "Your Impact",
    },
    breadcrumbs: {
      breadcrumb: "Breadcrumb",
    },
    components: {
      reusableComponents: "Reuseable Components",
      congratsComponent: "Congrats component",
      tableComponent: "Table component",
      chatChannelComponent: "Chat channel",
      audienceComponent: "Audience",
      startTimeComponent: "Start time",
      gameTypeComponent: "Game type",
      components: "Components",
      clickMe: "Click me",
      loadingState: "Loading state",
      emptyState: "Empty state Default",
      emptyStateWithActionButton: "Empty state with action button",
      ariaLabelEmptyState: "Empty state aria label",
      ariaLabelTableSection: "Table section aria label",
      ariaLabelTableContent: "Table content aria label",
      ariaLabelTablePagination: "Table pagination aria label",
      withBorder: "With border",
      dataCell: "Data cell",
      dataCellComponent: "Data cell component",
      formInputs: {
        title: "Form Input Elements",
        dpMultiWithSearch: "Dropdown Multi-Select with Search",
        dpMultiWithoutSearch: "Dropdown Multi-Select without Search",
        selectInterest: "Select Interest",
        selectCounselor: "Select Counselor",
        emptyResultsInterests: "No Interests Found",
        emptyResultsCounselors: "No Counselors Found",
        pillsMultiSelect: "Pills Multi-Select",
        yesNoToggle: "Yes No Toggle",
        dateSelector: "Date Selector",
        dateRangeSelector: "DateRange Selector",
        datePlaceholder: "Pick a date",
        tokenPlaceholder: "Generic",
        tokenGeneric: "Generic comma separted input",
        tokenGenericSub: "Also can be separated by whitespace",
        zipCode: "Zip Code Input (with validation)",
        zipCodeSub: "Input must be 5 digits",
        zipPlaceholder: "Enter Zip codes",
      },
      tableTabs: {
        title: "Table tabs",
        download: "Download",
        dateUploaded: "Date uploaded",
        fileName: "File name",
      },
      dropdown: {
        selectOption: "Select Option",
      },
    },
    error: {
      user: "Error fetching user data",
      error: "Error: {{error}}",
      passwordStrength: {
        tooWeak:
          "Your password is too weak. Here are some dos and don'ts for passwords",
        symbols: "Don't stress about capitals, weird symbols, or numbers!",
        random:
          "It turns out, the most secure passwords are just random words.",
        pick: "Pick four words that you'll remember and separate them with spaces.",
        example: "Here's an example: house boat cereal putter",
      },
      organization: {
        loading: "Could not load user organization.",
        permissions:
          "This feature is only available for Pro and Premier partners. Please contact your Director of Partner Success or <supportLink>support@zeemee.com</supportLink> for information on upgrading.",
      },
      incorrectPassword: {
        lastAttempt:
          "Incorrect password. Your account will be locked after the next failed attempt. <forgotLink>Reset password?</forgotLink>",
      },
    },
    profile: {
      title: "User Profile",
      profilePhoto: "Profile Photo",
      name: "Name: {{name}}",
    },
    zeemeeFunnel: {
      datePickers: {
        compareTo: "compare to",
        chooseDate: "Choose date",
        removeComparison: "Remove Comparison",
      },
      chart: {
        titlePage: "Funnel Conversion",
        title: "Enrollment Funnel",
        singleFunnelDescription: "In Community vs Not in Community conversion ",
        multiFunnelDescription:
          "In Community vs Not in Community conversion for two different groups and time",
        conversion: "Conversion Rates",
        studentsByFunnelState: "Students by funnel state as of {{date}}",
        inCommunityVsNotInCommunity: "In Community vs. Not in Community",
        inCommunity: "In Community",
        notInCommunity: "Not in Community",
        share: "Share",
        enrolled: "Enrolled",
        melted: "Melted",
        inquired: "Inquired",
        applied: "Applied",
        admitted: "Admitted",
        committed: "Committed",
        funnelState: "Funnel State",
        error: "Error fetching funnel data",
      },
      funnelState: "Student List",
      studentsDescription: "Based on your selection in the funnel chart above",
      csvHeaders: {
        inCommunityCount: "In Community",
        notInCommunityCount: "Not In Community",
      },
    },
    engagement: {
      chartSectionTitle: "All activity over the past 13 months",
      charts: {
        groupChats: "Group Chats",
        directMessages: "Direct Messages",
        profileViews: "Student Profile Views",
        feedPostViews: "Feed Post Views",
        channelOpens: "Channel Opens",
        roommateMatch: "Friend & Roommate Searches",
      },
      chartError: "Error loading chart",
      share: "Share",
    },
    adoption: {
      title: "Adoption & Engagement",
      tabs: {
        student: "Adoption",
        engagementData: "Engagement",
        commitmentIndex: "Commit Index",
      },
      communityGrowthChart: {
        title: "Community Growth",
        description:
          "Student adoption from summer before senior year through transition to college",
        menuOptions: {
          share: "Share",
        },
        loadingError: "Error load community growth chart.",
      },
      bentosAdoption: {
        title: "A quick look at your {{cohort}} cohort",
      },
      bentosEngagement: {
        title: "Activity in your community since August 1st",
      },
      chartAdoption: {
        title: "Community Adoption by Funnel State",
        description:
          "Community participation levels across the admissions funnel",
        menuOptions: {
          share: "Share",
        },
        csvHeaders: {
          inCommunityPercent: "In Community %",
          notInCommunityPercent: "Not In Community %",
          inCommunityCount: "In Community Count",
          notInCommunityCount: "Not In Community Count",
        },
      },
      studentCarousel: {
        title: "New Students in Your Community",
      },
      currentFunnelStates: {
        title: "Current Funnel States",
        subtitle:
          "Distribution of students in your community by active funnel state",
        menuOptions: {
          share: "Share Link",
        },
        funnelStates: {
          inquired: "Inquired",
          applied: "Applied",
          admitted: "Admitted",
          committed: "Committed",
          withdrawn: "Commitment Withdrawn",
        },
        error: {
          loadingError:
            "There was a problem loading the data, please refresh and try again",
        },
      },
    },
    predictiveModels: {
      title: "Predictive Models",
      tabs: {
        applyIndex: "Apply Index",
        commitIndex: "Commit Index",
        meltIndex: "Melt Index",
        yieldIndex: "Yield Index",
        retainIndex: "Retain Index",
      },
      bentos: {
        title: "A quick look at your {{cohort}} cohort",
        highCount: {
          title: "High Index Students",
          tooltip: "Students with a high {{type}} index",
        },
        committedHighCount: {
          title: {
            default: "High Index Commits",
            apply: "High Index Applicants",
          },
          count: "{{committedHighCount}}%",
          tooltip: {
            commit: "Committed students with a high commit index",
            apply: "Applicants with a high apply index",
            riseDefault: "Committed students with a high {{type}} index",
          },
        },
        upTrendCount: {
          title: "Up-Trending Students",
          tooltip: "Students whose {{type}} score has increased",
        },
        downTrendCount: {
          title: "Down-Trending Students",
          tooltip: "Students whose {{type}} score has decreased",
        },
        error: {
          loadingError: "Error loading data",
        },
      },
      chart: {
        title: "{{index}} Index Distribution",
        defaultSubtitle: "{{index}} indexes for all students in your funnel",
        tabs: {
          admitsOnly: "Admits Only",
          applicantsOnly: "Applicants Only",
          allStudents: "All Students",
        },
        indexes: {
          apply: "Apply",
          commit: "Commit",
          melt: "Melt",
          yield: "Yield",
        },
        onlyInCommunity: "Only In-Community",
        xAxis: "Number of Students",
        commitmentType: {
          applied: "Applied",
          notApplied: "Have not applied",
          committed: "Committed",
          notCommitted: "Not Committed",
        },
        category: {
          high: "High",
          mediumHigh: "Med-High",
          medium: "Medium",
          mediumLow: "Med-Low",
          low: "Low",
        },
        menuOptions: {
          share: "Share",
          exportAsImage: "Export as Image",
          successCopied: "Link copied",
        },
        emptyMessage: "No data for your community yet",
        error: {
          loadingError:
            "There was a problem loading the data, please refresh and try again",
        },
      },
      list: {
        tabs: {
          highTitle: "High Index",
          mediumHighTitle: "Medium-High Index",
          mediumTitle: "Medium Index",
          mediumLowTitle: "Medium-Low Index",
          lowTitle: "Low Index",
          highSubtitle: "Students with a high {{index}} as of {{date}}",
          mediumHighSubtitle:
            "Students with a medium-high {{index}} as of {{date}}",
          mediumSubtitle: "Students with a medium {{index}} as of {{date}}",
          mediumLowSubtitle:
            "Students with a medium-low {{index}} as of {{date}}",
          lowSubtitle: "Students with a low {{index}} as of {{date}}",
        },
        columns: {
          name: "Name",
          score: "Score",
          changedTo: "Changed to {{index}}",
          previousBucket: "Previous Index",
          funnelState: "Funnel State",
        },
        communityStatus: "Community Status",
        inCommunity: "In-Community",
        notInCommunity: "Not-In-Community",
        never: "Never",
        view: "View",
        export: "Export",
        previousBucket: "Previous Index",
        funnelStateFilter: "Funnel State",
        errorLoadingData:
          "There was a problem loading the data, please refresh and try again",
        buckets: {
          high: "High",
          mediumHigh: "Med-High",
          medium: "Medium",
          mediumLow: "Med-Low",
          low: "Low",
          none: "-",
        },
        menuOptions: {
          share: "Share",
          successCopied: "Link copied",
        },
        emptyState: "No data for your community yet",
      },
    },
    gamesAndLiveEvents: {
      title: "Games & Live Events",
      createNewEvent: "New Event",
      bento: {
        title: "A quick look at your games & events since August",
        totalEvents: "Total Events",
        totalEventsToolTips: "Number of game & events hosted in your community",
        totalParticipants: "Total Participants",
        totalParticipantsToolTips:
          "Total number of participants in all of your games & events",
        totalMessages: "Total Messages",
        totalMessagesToolTips:
          "Total number of chat messages students sent during all of your games & events",
        totalChannelViews: "Total Channel Views",
        totalChannelViewsToolTips:
          "Number of times students have opened channels in your community during all of your games & events",
      },
      table: {
        tabs: {
          scheduled: "Scheduled",
          completed: "Completed",
        },
        eventTypes: {
          liveEvent: "Live Event",
          automatedGame: "Automated Game",
        },
        audience: {
          everyone: "Everyone",
          applicants: "Applicants",
          admits: "Admits",
          commits: "Commits",
          other: "Other",
        },
        scheduled: {
          title: "Scheduled Events",
          subtitle: "Upcoming games & events",
          emptyState: "You don't have any scheduled events",
          createNewEvent: "Create new event",
          columns: {
            eventName: "Event Name",
            eventType: "Event Type",
            startTime: "Start Time",
            audience: "Audience",
            chatChannel: "Chat Channel",
          },
          actions: {
            edit: "Edit",
            delete: "Delete",
          },
          confirmDialogs: {
            delete: {
              title: "Are you sure?",
              message: "Are you sure you want to delete this event?",
              success: "Successfully deleted event",
              error: "Error deleting event",
            },
          },
          filters: {
            eventType: "Event Type",
            audience: "Audience",
            chatChannel: "Chat Channel",
          },
        },
        completed: {
          title: "Completed Events",
          subtitle: "Past games & live events",
          emptyState: "You don't have any completed events",
          createNewEvent: "Create new event",
          columns: {
            eventName: "Event Name",
            eventType: "Event Type",
            startTime: "Start Time",
            chatChannel: "Chat Channel",
            totalMessages: "Messages",
            participants: "Participants",
          },
          actions: {
            details: "Details",
          },
          filters: {
            eventType: "Event Type",
            chatChannel: "Chat Channel",
          },
        },
        actions: {
          exportCsv: "Export to CSV",
          exportImage: "Export as Image",
          share: "Share",
          shareSuccess: {
            title: "Copied!",
            description: "A shareable link has been copied to your clipboard.",
          },
        },
      },
    },
    manageProfile: {
      title: "My Profile",
      tabs: {
        yourProfile: "Profile",
        funFacts: "Fun Facts",
        socials: "Socials",
        contactInfo: "Contact Info",
        notifications: "Notifications",
        password: "Password",
      },
      editProfile: {
        title: "Basic information",
        subTitle:
          "View and update your personal details and account information.",
        firstName: "First name",
        firstNameHint: "Add your first name here",
        firstNameBlank: "First name can not be empty",
        lastName: "Last name",
        lastNameHint: "Add your last name here",
        lastNameBlank: "Last name can not be empty",
        bio: "Bio",
        bioHint: "Add your bio here",
        hometown: "Hometown",
        hometownHint: "Search for your hometown",
        interests: "Interests",
        interestsHint: "Select interests",
        interestsEmpty: "No interests found",
        interestsLimit: "You've reached the limit of 20 interests",
        major: "Major",
        majorsHint: "Select majors",
        majorsEmpty: "No majors found",
        majorsLimit: "You've reached the limit of 2 majors",
        imageFormatError:
          "You're trying to upload an unsupported file format. Please upload a JPEG, PNG, GIF, or WEBP image.",
        imageSizeError:
          "The image you're trying to upload is too large. Please make sure the file is 5mb or less.",
        profile: "Profile",
        updateSuccess: "Profile updated successfully",
        updateError: "Failed to update profile",
        ariaError: "Error",
      },
      contactInfo: {
        title: "Email and Phone",
        subTitle:
          "View and update your personal details and account information.",
        privacyNotice:
          "Your email and phone number will not be shared with students",
        email: "School Email address",
        emailHint: "Add your school email address",
        phoneNumber: "Phone number",
        phoneNumberHint: "+1 327 555 1234",
        updateSuccess: "Contact information updated successfully",
        updateError: "Failed to update contact information",
        ssoAlert: {
          title: "Your email must match your SSO login",
          message:
            "If your email address here doesn't match your SSO login for your school, you won't be able to log in to Insights. Please make sure it matches. You can contact your SSO contact for your school to update your email address there if you need to.",
        },
        errors: {
          emailRequired: "Email is required",
          emailInvalid: "Invalid email",
          phoneRequired: "Phone number is required",
          phoneMustStartWithPlus:
            "Phone number must start with '+' and country code",
          phoneInvalid: "Invalid phone number",
        },
      },
      editSocials: {
        title: "Social Media",
        subTitle:
          "Share your institution's social media handles on your profile page.",
        unsavedChangesAlert: {
          title: "Discard changes?",
          message: "You haven't saved the changes to your socials.",
          discard: "Leave anyway",
        },
      },
      funFacts: {
        title: "Fun Facts",
        subTitle: "Help students get to know you",
        tabs: {
          incomplete: "Incomplete",
          completed: "Completed",
        },
        buttons: {
          answer: "Answer",
          edit: "Edit",
        },
        emptyStates: {
          noUnanswered: "You’ve answered all the fun facts",
          noAnswered: "You don’t have any fun facts yet",
        },
        toast: {
          createSuccess: "Fun fact saved successfully",
          updateSuccess: "Fun fact updated successfully",
          deleteSuccess: "Fun fact deleted successfully",
          error: "Failed to save fun fact",
        },
      },
    },
    chatGames: {
      title: "Games & Live Events",
      newEvent: "New Event",
      chart: {
        title: "Funnel State of Participants",
        menuOptions: {
          export: "Export to CSV",
          exportAsImage: "Export as Image",
          share: "Share",
          successCopied: "Link copied",
        },
      },
      delete: {
        success: "Feed post deleted successfully",
        error: "Failed to delete feed post",
      },
    },
    feedPost: {
      title: "Feed Posts",
      communityToolsOverview: {
        tabs: {
          feedPost: {
            tabName: "Feed Posts",
            title: "Active & Scheduled",
            subtitle:
              "A quick summary of active & scheduled feed posts in your community.",
            emptyState: "You don't have any scheduled or active feed posts.",
          },
        },
      },
      bento: {
        title: "A quick look at your feed engagement since August",
        officialPosts: "Official Posts",
        officialPostsToolTip: "Feed posts made by community officials",
        officialPostViews: "Official Post Views",
        officialPostViewsToolTip:
          "Total number of student views on official posts in your feed",
        featuredStudentPosts: "Featured Student Posts",
        featuredStudentPostsToolTip:
          "“Featured Student” posts created by ZeeMee in your feed",
        featuredStudentPostViews: "Featured Student Post Views",
        featuredStudentPostViewsToolTip:
          "Total number of student views on “Featured Student” posts in your feed",
      },
      recentlyViewed: "Students viewing your posts",
      table: {
        tabs: {
          scheduled: "Scheduled",
          active: "Active",
          archived: "Archived",
          draft: "Draft",
        },
        columns: {
          name: "Description",
          postedBy: "Posted by",
          ctaEnabled: "CTA enabled",
          views: "Views",
          postedAt: "Published",
        },
        createNewPost: "Create new post",
        scheduled: {
          title: "Upcoming Feed Posts",
          subtitle: "A quick summary of your scheduled feed posts",
          emptyState:
            "You don't have any scheduled feed posts. Add one in the Zeemee app!",
          columns: {
            scheduledFor: "Scheduled For",
          },
          actions: {
            edit: "Details",
            delete: "Delete",
          },
          confirmDialogs: {
            delete: {
              title: "Are you sure?",
              message: "Are you sure you want to delete this post?",
            },
          },
          filters: {
            postedBy: "Posted by",
            ctaEnabled: "CTA enabled",
          },
        },
        active: {
          title: "Active Feed Posts",
          subtitle: "A quick summary of your active feed posts",
          emptyState:
            "You don't have any feed posts. Create one in the Zeemee app!",
          actions: {
            edit: "Details",
            delete: "Delete",
            archive: "Archive",
          },
          confirmDialogs: {
            delete: {
              title: "Are you sure?",
              message: "Are you sure you want to delete this post?",
            },
          },
          filters: {
            postedBy: "Posted by",
            ctaEnabled: "CTA enabled",
          },
        },
        archived: {
          title: "Archived feed posts",
          subtitle: "A quick summary of your archived feed posts",
          emptyState: "You don't have any archived feed posts.",
          columns: {
            archivedAt: "Archived at:",
          },
          actions: {
            restore: "Restore",
            delete: "Delete",
          },
          confirmDialogs: {
            delete: {
              title: "Are you sure?",
              message: "Are you sure you want to delete this post?",
            },
            restore: {
              title: "Restore post?",
              message: "Are you sure you want to restore this post?",
            },
          },
          filters: {
            postedBy: "Posted by",
            ctaEnabled: "CTA enabled",
          },
        },
        draft: {
          title: "Draft feed posts",
          subtitle: "A quick summary of your draft feed posts",
          emptyState: "You don't have any draft feed posts.",
          columns: {
            lastModified: "Last modified:",
            createdBy: "Created by:",
          },
          actions: {
            edit: "Edit",
            delete: "Delete",
            publish: "Publish",
          },
          confirmDialogs: {
            delete: {
              title: "Are you sure?",
              message: "Are you sure you want to delete this post?",
            },
            publish: {
              title: "Publish post?",
              message: "Are you sure you want to publish this post?",
            },
          },
          filters: {
            createdBy: "Created by",
            ctaEnabled: "CTA enabled",
          },
        },
        actions: {
          exportCsv: "Export to CSV",
          exportImage: "Export as Image",
          share: "Share",
          shareSuccess: {
            title: "Copied!",
            description: "A shareable link has been copied to your clipboard.",
          },
        },
        editDialog: {
          title: "Edit your feed post",
          message:
            "Feed posts edits in the dashboard are coming soon! For now, contact your Director of Partner Success for help editing this post.",
          close: "Close",
        },
      },
    },
    editEvent: {
      tabs: {
        chooseEvent: "Event Type",
        liveEvent: "Event Details",
        gameEvent: "Game Details",
      },
      newEvent: {
        title: "New Event",
        cardTitle: "Choose Event Type",
        cardDescription: "Choose the type of event you’d like to schedule",
        optionCard1Title: "Live Event",
        optionCard1Description:
          "Schedule a live event that your team host in your community channels",
        optionCard2Title: "Automated Game",
        optionCard2Description:
          "Schedule an automated game, run by our game bot, in your community channels",
        upsellModal: {
          title: "Whoops! You don’t have access to Automated Games yet.",
          description:
            "Please contact your Director of Partner Success or <a href='mailto:support@zeemee.com' target=_blank>support@zeemee.com</a> to add this tool.",
        },
      },
      liveEvent: {
        title: "New Live Event",
        cardTitle: "Event Details",
        cardDescription: "Enter the information for your upcoming live event",
      },
      game: {
        title: "Automated Game",
        cardTitle: "Game Details",
        cardDescription:
          "Enter the information for your upcoming automated game",
      },
    },
    eventDetails: {
      fallbackTitle: "Event Details",
      tabs: {
        details: "Event Details",
        results: "Results",
      },
      details: {
        titles: {
          eventType: "Event Type",
          eventName: "Event Name",
          audience: "Audience",
          chatChannel: "Chat Channel",
          startDate: "Start Date and Time",
          gameType: "Game Type",
          gameVariation: "Game Variation",
        },
        eventType: {
          liveEvent: "Live Event",
          automatedGame: "Automated Game",
        },
        audienceType: {
          everyone: "All followers",
          admits: "Admitted students",
          applicants: "Applied students",
          commits: "Committed students",
          other: "Other",
        },
      },
      results: {
        bentos: {
          totalParticipants: "Total Participants",
          totalChannelOpens: "Total Channel Opens",
          totalMessages: "Total Messages",
          studentsWhoMessaged: "Students who Messaged",
          loadingError: "Error loading data",
        },
        chart: {
          title: "Funnel State of Participants",
          ariaSubtitle: "Funnel State of Participants",
          menuOptions: {
            share: "Share",
          },
          loadingError: "Error loading data",
          emptyMessage: "Still calculating - check back soon!",
          successCopied: "Link copied",
          export: {
            headers: {
              group: "Group",
              students: "Students",
              funnelState: "Funnel State",
            },
          },
        },
        studentList: {
          errorMessage:
            "There was an error loading the participant list. Please try again.",
          title: "Participant List",
          description: "{{totalCount}} total participants",
          selectedBarDescription:
            "{{totalCount}} participants who were {{barLabel}} on the day of this event",
        },
      },
    },
    communityTools: {
      getStarted: {
        title: "Engagement Toolbox",
        subtitle:
          "Create campaigns to support students throughout the enrollment journey",
        bulkMessage: {
          label: "Send a Bulk Message",
          flow: "Create Bulk Message",
        },
        scheduledLiveEvent: {
          label: "Schedule a Game",
          flow: "Create Automated Game",
        },
        competitorMatch: {
          label: "Schedule a Competitor Match",
          flow: "Create Competitor Match",
        },
        dab: {
          label: "Set up Dynamic Action Buttons",
          flow: "Create DAB",
        },
        feedPost: {
          label: "Create a new Post",
          flow: "Create Feed Post",
        },
        liveEvent: {
          label: "Schedule a Live Event",
          flow: "Schedule Live Event",
        },
        featureLabel: "{{label}}{{requiresUpgrade}}",
        requiresUpgrade: " (requires upgrade)",
        upgradeRequired: "Upgrade required",
      },
    },
    channelRequest: {
      title: "Chat Channel Request",
      cardTitle: "Channel Request Form",
      cardDescription:
        "Complete the form below to provide important information about your new chat channel.",
    },
    testing: {
      placeholder: "Placeholder",
    },
    studentCard: {
      admitted: "Admitted 2025",
      noLocation: "No location added",
      noHighSchool: "No high school added",
      noBio: "No bio added",
      noMajors: "No majors added",
      noInterests: "No interests added",
      notFound: "Student not found",
      top1: "🔥 Top 1%",
      top5: "🔥 Top 5%",
      top10: "🔥 Top 10%",
      top25: "🔥 Top 25%",
      socialLink: "Social media link",
      openCRM: "Open {{firstName}}'s CRM page.",
      funnelState: {
        title: "Funnel State",
        subtitle: "This student's progress through your funnel",
        dateNotAvailable: "Date not available",
      },
      bento: {
        source: "Source",
        sourceToolTip: "The way in which a student joined your community",
        sourceToolTipBullet1:
          "Organic students joined your community before appearing in your data (new inquiries)",
        sourceToolTipBullet2:
          "Community matched students were in your funnel & already on ZeeMee following other institutions, then added to your community by ZeeMee",
        sourceToolTipBullet3:
          "Invited students joined via a link (e.g. from ZeeMee’s monthly SMS, from one of your emails, from a QR code, etc.)",
        funnelState: "Funnel State",
        funnelStateLabel: "Funnel State",
        funnelStateDescription: "Funnel state of the student",
        commitIndex: "Commit Index",
        commitIndexToolTip:
          "This student’s likelihood to commit to your institution based on our predictive model",
        goingStatus: "Going Status",
        goingStatusToolTip:
          "This student’s self-reported enrollment intention in your community",
        joined: "Joined",
        updated: "Updated",
        asOf: "As of",
        high: "High",
        mediumHigh: "Medium High",
        medium: "Medium",
        mediumLow: "Medium Low",
        low: "Low",
        going: "Going",
        notGoing: "Not Going",
        undecided: "Undecided",
        communityMatch: "Community Match",
        invited: "Invited",
        competitorMatch: "Competitor Match",
        organic: "Organic",
        communityStatus: "Community Status",
        communityStatusToolTip: "The student’s status in your ZeeMee community",
        communityStatusToolTipBullet1:
          "Not In Community students aren't currently part of your ZeeMee community",
        noJoinedDate: "Join date unavailable",
        leftCommunity: "Student left community",
        noUpdateDate: "Update date unavailable",
        notInCommunity: "Not in Community",
        statusLeftCommunity: "Left Community",
        leftOn: "Left on {{date}}",
        leftOnUnavailable: "Unfollow date is unavailable",
        crmDataOnly: "CRM data only",
        status: "Status",
      },
      predictiveScoreGraphs: {
        actions: {
          exportCSV: "Export to CSV",
          share: "Share",
        },
        export: {
          headers: {
            date: "Date",
            score: "Score",
          },
          successMessage: "Data exported to CSV",
          failureMessage: "Failed to export CSV",
        },
        tooltipMessage: "Score: {{score}}",
        title: "Prediction Scores",
        subtitle:
          "See how {{fname}} will move through your funnel. Click on a box below to see {{fname}}'s scores over time",
        emptyMessage:
          "This student’s {{type}} score hasn’t been calculated yet",
        errorMessage: "Failed to load {{type}} index data",
        indexes: {
          high: "High",
          mediumHigh: "Med-High",
          medium: "Medium",
          mediumLow: "Med-Low",
          low: "Low",
        },
        cardButtons: {
          apply: "Apply",
          applyAria: "Apply score button",
          commit: "Commit",
          commitAria: "Commit score button",
          yield: "Yield",
          yieldAria: "Yield score button",
          melt: "Melt",
          meltAria: "Melt score button",
        },
        riseApplyGraph: {
          title: "Apply Score",
          subtitle:
            "A look at how their likelihood to apply is changing over time",
        },
        riseCommitGraph: {
          title: "Commit Score",
          subtitle:
            "A look at how their likelihood to commit is changing over time",
        },
        riseMeltGraph: {
          title: "Melt Score",
          subtitle:
            "A look at how their likelihood to melt is changing over time",
        },
        riseYieldGraph: {
          title: "Yield Score",
          subtitle:
            "A look at how their likelihood to yield is changing over time",
        },
        commitScoreGraph: {
          title: "Commit Index",
          subtitle:
            "A look at how their likelihood to commit is changing over time",
        },
      },
      contact: {
        title: "Contact",
        email: "Email",
        phone: "Phone",
        noEmail: "No email for this student",
        noPhone: "No phone number for this student",
        copySuccess: "Copied!",
        copyEmailSuccess: "Student email copied to your clipboard",
        copyPhoneSuccess: "Student phone copied to your clipboard",
        copyButton: "Copy",
      },
      details: {
        title: "Details",
        assignedCounselor: "Assigned Counselor",
        noAssignedCounselor: "No assigned counselor",
        joined: "Joined",
        cohortYear: "Cohort year",
        studentType: "Student Type",
        firstYear: "First Year",
        lookingForRoommate: "Looking for a roommate?",
        roommateMatch: "Roommate Match",
        finishedQuiz: "Finished Quiz",
        hasntFinishedQuiz: "Hasn't Finished Quiz",
        schoolsFollowing: "# of Schools Following",
        admittedTo: "Admitted to",
        eventsAttended: "# of Events Attended",
        noEmail: "No email provided",
        noPhone: "No phone provided",
        noGraduationYear: "No graduation year provided",
        goingStatus: "Going",
        hasCompletedRoommateQuiz: "Roommate Match",
      },
      crmData: {
        title: "CRM Data",
        crmId: "CRM ID",
        completedFafsa: "Completed FAFSA",
        visitedCampus: "Visited Campus",
      },
      funFacts: {
        title: "Fun Facts",
        subtitle: "Get to know this student",
        dotAria: "Go to slide {{slideNum}}",
        emptyMessage: "This student doesn’t have fun facts yet",
        errorMessage: "Error loading fun facts",
      },
      studentTimeline: {
        title: "Student Timeline",
        subtitle: "See how this student has engaged with you recently",
        tabs: {
          allEngagements: "All Engagements",
          highlights: "Highlights",
        },
        emptyMessage: "The Student Timeline is coming soon",
      },
      personas: {
        title: "Personas",
        description:
          "A peek at how {{name}} thinks, acts, and engages in their social communities",
        readMore: "Read more",
        communicationTips: "Communication Tips",
        lifestyle: "LIFESTYLE",
        behavior: "BEHAVIOR",
        roommate: "ROOMMATE",
        emptyState: {
          title: "In Progress",
          message: "Still getting to know {{name}}",
        },
      },
      gridView: {
        name: "Name",
        cohortYear: "Cohort Year",
        location: "Location",
        funnelState: "Funnel State",
        studentType: "Student Type",
        phone: "Phone",
        assignedCounselor: "Assigned Counselor",
        commitIndex: "Commit Index",
        applyIndex: "Apply Index",
        yieldIndex: "Yield Index",
        meltIndex: "Melt Index",
        goingStatus: "Going Status",
        lastActive: "Last Active",
        majors: "Major",
        interests: "Interests",
        lastSignInAt: "Last Active",
        major: "Major",
        emptyFilterStateTitle:
          "We didn't find any students. Adjust the flters and try again.",
        emptyStateTitle: "No students found",
        errorStateTitle:
          "There was a problem loading your data. Please refresh and try again.",
        messages: "Messages",
      },
      overflowMenu: {
        share: "Share",
        banFromOrg: "Ban from Community",
        reportUser: "Report User",
      },
    },
    studentCardPopover: {
      profile: "Profile",
      message: "Message",
      noBio: "No bio added",
    },
    studentList: {
      actions: {
        share: "Share",
        exportCsv: "Export to CSV",
        sendBulkMessage: "Send Bulk Message to List",
        menubarLabel: "Student list actions",
        openMenu: "Open menu",
        menubar_label: "Menubar label",
        open_menu: "Open menu",
        menu: "Menu",
      },
      toast: {
        shareSuccess:
          "URL copied to clipboard. You can now share this student list with others.",
        shareError: "Failed to copy URL to clipboard.",
        exportSuccess:
          "Export started. Your CSV file is being generated and will download shortly.",
        bulkMessageSuccess: "Create bulk message flow initiated.",
      },
      gridView: "Grid view",
      tableView: "Table view",
    },
    congrats: {
      ariaLabel: {
        congrats: "Congrats",
        congratsContent: "Congrats content",
        avatars: "Avatars",
        congratsActions: "Congrats actions",
        avatarContainer: "Avatar container",
        description: "Description",
      },
      copies: {
        createdGame: {
          title: "You've successfully created a new game!",
          description: "This game is scheduled for {{dateTime}}",
        },
        actionButtons: {
          title: "You've successfully setup Dynamic Action Buttons",
          description:
            "It may take a few seconds for students to see the new button in the app. You'll be contacted by email if there are any issues.",
        },
        sentPost: {
          title: "You've successfully sent a post!",
          description:
            "Your post has been sent to your school community feed post",
        },
        scheduledPost: {
          title: "You've successfully scheduled a post!",
          description: "Your post is scheduled to be made on {{dateTime}}",
        },
        bulkMessaging: {
          title: "You've successfully sent a bulk message!",
          description:
            "It may take a few minutes for all students to receive your message. You'll be contacted by email if there are any issues.",
        },
      },
      actions: {
        calendar: "Add to calendar",
        done: "Ok, I'm done",
      },
      students: "{{count}} students",
    },
    dataTable: {
      loadingTableContents: "Loading table contents",
      emptyState: "Empty state",
      noDataAvailable: "No data available",
      paginationInformation: "Pagination information",
      goToPreviousPage: "Go to previous page",
      goToNextPage: "Go to next page",
      tableFilters: "Table filters",
      currentFilter: "Current filter",
      clearFilters: "Clear filters",
      openFiltersMenu: "Open filters menu",
      filtersContainer: "Filters container",
      filterBy: "Filter by {{column}}",
      filterByValue: "Filter {{item}} by {{column}}",
      tableActions: "Table actions",
      openTableActionsMenu: "Open table actions menu",
      sortingControls: "Sorting controls",
      sortColumn: "Sort {{column}} column, currently {{sortLabel}}",
      sortOptions: "Sort options for {{column}} column",
      sortDescending: "Sort {{column}} descending",
      sortAscending: "Sort {{column}} ascending",
      tableTitle: "Table title",
      noResultsFound: "No results found",
      page: "Page {{page}} of {{totalPages}}",
      pageOf: "{{page}} of {{totalPages}} Pages",
      dataTableContent: "Data table content",
      dataTableSection: "Data table section",
      tablePagination: "Table pagination",
      loadingState: "Loading state",
      loadingRow: "Loading row data",
      emptyStateCopy: "You don't have any buttons setup yet. Get started now!",
    },
    searchableCombobox: {
      defaultPlaceholder: "Select an option...",
      defaultSearchPlaceholder: "Search...",
      defaultEmptyResults: "No results found.",
    },
    chart: {
      previousYear: "Previous Year",
      removePreviousYearFilter: "Remove previous year filter",
      users: "Users",
      groupChats: "Group Chats",
      description: "Chart data visualization",
      actions: {
        exportCSV: "Export to CSV",
        share: "Share",
        exportAsImage: "Export as Image",
      },
      intervals: {
        "7days": "7 days",
        "30days": "30 days",
        "3months": "3 months",
        "6months": "6 months",
        "12months": "12 months",
        currentCycle: "Current Cycle",
        custom: "Custom",
        lastPeriod: "Last {{period}}",
        selectInterval: "Select time interval",
      },
      compareTo: {
        label: "compare to",
        previousYear: "Previous Year",
        removePreviousYear: "Remove previous year filter",
        selectOption: "Select option",
      },
      dataInterval: {
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
        selectInterval: "Select data interval",
      },
      dateRange: {
        placeholder: "Select date range",
      },
      filters: {
        showFilters: "Show filters",
        filterTooltip: "Filter chart data",
        activeFilters: "{{count}} active filters",
      },
      line: {
        current: "Current",
        previousYear: "Previous Year",
      },
    },
    funnelGroups: {
      applied: "Applied",
      deferred: "Deferred",
      committed: "Committed",
      inquired: "Inquired",
      applicationStarted: "Application Started",
      applicationComplete: "Application Complete",
      denied: "Denied",
      waitlisted: "Waitlisted",
      admitted: "Admitted",
      accepted: "Accepted",
      acceptedDeclined: "Acceptance Declined",
      acceptanceDeclined: "Acceptance Declined",
      commitmentWithdrawn: "Commitment Withdrawn",
      enrolled: "Enrolled",
      withdrawn: "Withdrawn",
      melted: "Melted",
      applicantsOnly: "Applicants Only",
      admitsOnly: "Admits Only",
      allStudents: "All Students",
      applicantsOnlyCommitted: "Applicants Only - Committed",
      admitsOnlyCommitted: "Admits Only - Committed",
      allStudentsApplied: "All Students - Applied",
      allStudentsCommitted: "All Students - Committed",
    },
    banFromOrg: {
      confirmDialog: {
        title: "Are you sure?",
        message:
          "Are you sure you want to ban this student from your community?",
      },
      successMessage: "This student has been banned",
      errorTitle: "Oops something went wrong!",
      errorMessage:
        "Please try again or reach out to your Partner Success Director.",
    },
    reportContent: {
      reportUser: {
        dialog: {
          title: "Report User",
          uploadTitle:
            "1. Please attach a screenshot of the issue youd like to report.",
          uploadContentTitle: "Drag and drop your screenshot here",
          uploadContentSubtitle: "Or select a file from your computer",
          reasonTitle: "2. Why are you reporting this user?",
          reasonOption1: "Fake account",
          reasonOption2: "Bullying/Trolling",
          reasonOption3: "Stalking/Harassment",
          reasonOption4: "Posting inappropriate things",
          reasonOption5: "Posting spam",
          reasonOption6: "Something else",
          sendButtonLabel: "Send Report",
          fileAttached: "File attached: {{image}}",
          sending: "Sending...",
          formAria: "Report user dialog form",
        },
        toast: {
          title: "Report sent!",
          message: "Your report has been submitted.",
          errorTitle: "Oops something went wrong!",
          errorMessage:
            "Please try again or reach out to your Partner Success Director.",
        },
      },
    },
    organizationHeader: {
      selectOrg: "Select Organization",
      noOrgsFound: "No Organizations Found.",
    },
    chat: {
      chatUserDisplayWrapper: {
        notStudentTitle: "Can't open profile page",
        notStudentText: "Only students have profile pages in Insights.",
      },
    },
    metrics: {
      comparisons: {
        noData: "data unavailable",
        noDataLastCycle: "historical data unavailable",
        yearOverYear: "{{percentChange}} year-over-year",
        vsZeroLastCycle: "vs. 0 last cycle",
        vsZeroLastYear: "vs. 0 last year",
        fromLastCycle: "{{percentChanged}} from last cycle",
        vsLastCycle: "vs. {{percentChanged}} last cycle",
        vsLastCyclePercent: "vs. {{percentChanged}}% last cycle",
        fromLastCycleSuffix: "from last cycle",
      },
      communityMembers: "Community Members", // TODO: update this cohort
      communityMembersToolTip: "Students currently in your community",
      joinedInLast30Days: "Joined In Last 30 Days",
      joinedInLast30DaysToolTip:
        "Students who joined your community in the last 30 days",
      joinedOrganically: "Joined Organically",
      joinedOrganicallyToolTip:
        "Students who joined your community before they became an inquiry in your data",
      communityMatched: "Community Matched",
      communityMatchedToolTip:
        "Students in your funnel who were already on ZeeMee following other institutions, then added to your community by ZeeMee",
      invitedFollowers: "Invited Followers",
      invitedFollowersToolTip: "",
      loadingError:
        "There was a problem loading the data, please refresh and try again",
      groupChats: "Group Chats",
      groupChatsToolTip: "Chat messages sent in your community's channels",
      directMessage: "Direct Messages",
      directMessageToolTip:
        "Direct messages & private group messages sent between two or more students in your community",
      profileView: "Student Profile Views",
      profileViewToolTip:
        "Number of times students in your community have viewed each other's profiles",
      feedPostView: "Feed Post Views",
      feedPostViewToolTip:
        "Total number of views on posts made by community officials in your feed",
    },
    teamManagement: {
      invite: "Invite Teammate",
      title: "{{- organization}}'s Team",
      seatAlert: {
        limitReached: "Seat Limit Reached",
        description:
          "Your community has used all of its seats for officials. Contact your Director of Partner Success or email <1>support@zeemee.com</1> to learn how you can add more.",
      },
      permissionAlert: {
        title: "Missing Manage Permissions",
        description:
          "You don't have permission to manage teammates for your ZeeMee community.",
      },
      table: {
        counselor: "Counselor",
        influencer: "Influencer",
        name: "Name",
        role: "Role",
        phone: "Phone",
        email: "Email",
        lastLogin: "Last Login",
        invitedDate: "Date of Invitation",
        edit: "Edit",
        inviteTeammate: "Invite Teammate",
        title: "Your Team",
        description: "You have {{seats}} seats remaining",
        default: "Default",
        resend: "Resend",
        remove: {
          title: "Are you sure?",
          description: "Are you sure you want to delete this team member?",
          success: "Successfully removed team member",
          error: "Error removing team member",
        },
        teammates: {
          title: "Teammates",
          empty: "Your community has no teammates at the moment",
          emptyButton: "Invite a Teammate",
        },
        invited: {
          title: "Pending Invites",
          empty: "Your community has no pending invites",
          emptyButton: "Invite a Teammate",
          delete: {
            title: "Are you sure",
            description: "Are you sure you want to delete this invitation?",
            success: "Successfully deleted invitation",
            error: "Error deleting invitation",
          },
          resend: {
            success: "Successfully resent invitation",
            error: "Error resending invitation",
          },
        },
      },
      inviteForm: {
        details: {
          tab: "Details",
          title: "Basic Information",
          description: "Tell us about the team member you'd like to invite.",
          firstName: "First Name",
          lastName: "Last Name",
          email: "School Email",
          phoneNumber: "Mobile Phone Number",
          role: "Role",
          counselor: "Counselor",
          influencer: "Influencer",
          rolePlaceholder: "Choose a role",
          sendInvitation: "Send Invitation",
          submitSuccess: {
            title: "Success!",
            description: "Your invitation has been sent.",
          },
          submitError: {
            title: "Oops something went wrong!",
            description:
              "Please try again or reach out to your Partner Success Director",
          },
        },
      },
    },
    upgrade: {
      features: {
        title: "You don't have access to {{feature}} yet.",
        message:
          "Please contact your Director of Partner Success or <supportLink>support@zeemee.com</supportLink> to add {{feature}}.",
        modelsTitle: "Your data analysis is still in progress",
        modelsMessage:
          "We’re still working on your RISE predictive models. Check back soon for access!",
      },
      permission: {
        title: "You don't have access to this feature.",
        message:
          "This option is only available for Pro and Premier partners. Please contact your Director of Partner Success or <supportLink>support@zeemee.com</supportLink> for information on upgrading.",
      },
      back: "Back",
    },
    acceptInvitation: {
      title: "Accept your invitation from {{organization}}",
      firstName: "First Name",
      lastName: "Last Name",
      email: "School Email",
      phoneNumber: "Mobile Phone Number",
      password: {
        label: "Password",
        enterPassword: "Enter a password",
        passwordConfirm: "Retype password",
      },
      helpInfo:
        "Contact <1>support@zeemee.com</1> to update your account contact information.",
      errors: {
        required: "Required",
        passwordMismatch: "Passwords do not match",
        support: {
          title: "Something went wrong",
          description: "Please contact <1>support@zeemee.com</1> to get help.",
        },
        strongerPassword: "Use a stronger password",
      },
      success: {
        title: "Welcome to ZeeMee",
        allSet: "Your official account with {{organization}} is all set!",
        clickHere: "Staff members can log in to ZeeMee Insights <0>here</0>.",
        download: "Download the ZeeMee app:",
        downloadApp: "Download ZeeMee",
      },
    },
    selectedStudentCountCard: {
      funnelState: {
        inquired: "Showing selected inquired students",
        applied: "Showing selected applicants",
        admitted: "Showing selected admitted students",
        committed: "Showing selected committed students",
        enrolled: "Showing selected enrolled students",
        melted: "Showing selected melted students",
      },
    },
    dataManagement: {
      title: "Data Management",
      table: {
        title: "Your Community's Shared Files",
        subtitle: "Shared files between you & ZeeMee",
        uploadDate: "Upload Date",
        fileName: "File Name",
        download: "Download",
        dateFormat: "MMMM d, yyyy",
        nameField: "name",
        empty: "No files uploaded yet",
      },
      upload: {
        button: "Upload File",
        uploading: "Uploading...",
        success: {
          title: "Success!",
          message: "Your file has been uploaded",
          close: "Close",
        },
        error: {
          title: "Oops something went wrong!",
          message:
            "Please try again or reach out to your Partner Success Director",
          close: "Close",
        },
      },
    },
    feedPostDetails: {
      title: "Feed Post Details",
      details: {
        delete: "Delete",
        deleteConfirm: {
          title: "Delete Feed Post?",
          message: "Are you sure you want to delete this feed post?",
        },
        tabs: {
          postDetails: "Post Details",
          results: "Results",
        },
        notFound: "Feed post not found",
      },
      postDetails: {
        postedBy: "Posted By",
        ctaButtonText: "CTA Button Text",
        ctaButtonUrl: "CTA Button URL",
        caption: "Caption",
        scheduledForLater: "Scheduled for Later",
        postedAt: "Posted At",
        noCtaButton: "No CTA button",
        noCaption: "No caption",
        feedPostImage: "Feed post image",
        feedPostVideo: "Feed post video",
      },
    },
    search: {
      button: "Search Students",
      prompt: "Type to search for students...",
      loading: "Searching for students...",
      noStudentsFound: "No results found.",
      description: "Search for Students",
      error:
        "Oops something went wrong!. Please try again or reach out to your Partner Success Director",
    },
    smartFilters: {
      names: {
        hotTargets: "Hot Targets",
        commitmentRisk: "Commitment Risk",
        myStudents: "My Students",
        mostEngaged: "Most Engaged",
        drifting: "Drifting",
        meltRisk: "Melt Risk",
        softApps: "Soft Apps",
      },
      subtitles: {
        admitsWho: "Admits who...",
        committedStudentsWho: "Committed Students who...",
        applicantsWithA: "Applicants with a...",
      },
      options: {
        highCommitIndexNotCommitted:
          "High Commit Index admits who have not committed",
        goingButNotCommitted:
          'Students who said they\'re "going" but have not committed',
        medCommitIndexNotCommitted:
          "Medium Commit Index admits who have not committed",
        highApplyIndexNotApplied:
          "High Apply Index students who have not applied",
        highYieldIndexNotApplied:
          "High Yield Index students who have not applied",
        hightYieldIndexNotCommitted:
          "High Yield Index students who have not committed",
        admitsNotGoing: 'indicated "not going"',
        admitsGoingElsewhere: 'indicated "going" to another school',
        admitsCommitScoreDown: "have a down-trending Commit Score",
        admitsMoreActiveOtherCommunity: "are more active in another community",
        top1: "Top 1%",
        top5: "Top 5%",
        top10: "Top 10%",
        top25: "Top 25%",
        // Drifting
        moreActiveElsewhere: "Students more active elsewhere",
        admitsMoreActiveElsewhere: "Admits more active elsewhere",
        committedMoreActiveElsewhere:
          "Committed students more active elsewhere",
        // Melt Risk
        committedNotGoing: 'indicated "not going"',
        committedGoingElsewhere: 'indicated "going" to another school',
        committedMoreActiveOtherCommunity:
          "are more active in another community",
        studentsCommittedBeforeDec31: "committed before December 31",
        committedWithHighMelt: "have a high Melt Index",
        committedWithLowYield: "have a low Yield Index",
        committedWithLowCommit: "have a low Commit Index",
        // soft apps
        appsLowApply: "low Apply Index",
        appsLowCommit: "low Commit Index",
        appsHighMelt: "high Melt Index",
        appsLowYield: "low Yield Index",
      },
      tooltips: {
        myStudents: "Students assigned to me",
        hotTargets: "High value students ready for a next step",
        commitmentRisk: "Students who are at risk of not committing",
        mostEngaged: "Your community's most engaged students",
        drifting: "Students becoming more active elsewhere",
        meltRisk: "Students at a higher risk of melting",
      },
      applyFilters: "Apply Quick Filter",
    },
    joinStateOptions: {
      inquired: "Inquired",
      applied: "Applied",
      admitted: "Admitted",
      committed: "Committed",
    },
    strategyBoard: {
      title: "Today's Strategy Board",
      empty: "No tasks found.",
      actions: {
        actionsForDate: "Actions for {{date}}",
        description:
          "Your personalized, high-impact outreach plan to connect with the right students and drive conversion",
        remaining: "{{count}} Remaining",
        notDone: "{{count}} Not Done",
        done: "{{count}} Done",
        skipped: "{{count}} Skipped",
        total: "{{count}} Total",
        feedback: "Provide feedback about this action",
        markAllDone: "Mark all as Done",
        markRemainingDone: "Mark remaining students as Done",
        errors: {
          markComplete: {
            title: "Could not mark action as complete.",
            description: "Please try again later",
          },
        },
      },
      capacityPicker: {
        title: "Welcome back, {{firstName}}!",
        capacity: "How much time can you invest in student outreach today?",
        capacityLow: "Just a little",
        capacityMedium: "Some",
        capacityHigh: "Quite a bit",
        inProgress:
          "We're still preparing your actions for today. Check back soon.",
        noActions: "We don't have any actions for you today.",
        noStudents:
          "You don't have any assigned students, so there aren't any actions for you.",
      },
      confirmationAlert: {
        markAllDone: "Mark all students as done?",
        markAllDoneDesc:
          "Do you want to mark all students in this action from <strong>Not Done</strong> to <strong>Done</strong>?",
        markRemainingDone: "Update all remaining students?",
        markRemainingDoneDesc:
          "This will change the status of all remaining students in this action who are <strong>Not Done</strong> to <strong>Done</strong>.",
        confirm: "Yes",
        cancel: "Cancel",
      },
      progress: {
        single: {
          title: "Today's progress",
          currentProgress: "Completed:",
          popover: {
            title: "Actions",
            completed: "Completed",
            skipped: "Skipped",
            remaining: "Remaining",
          },
        },
        team: {
          title: "Team progress",
          currentProgress: "Progress:",
          popover: {
            completed: "Actions Completed",
            skipRate: "Skip Rate",
            showAll: "Show all",
          },
          popoverDialog: {
            title: "Team Progress",
            members: "{{count}} members",
          },
        },
        congrats: {
          title: "Congratulations,<br/>you've finished today's actions!",
        },
      },
    },
    riseActionDetails: {
      action: "Action:",
      actions: "Actions",
      metrics: {
        done: "Done",
        notDone: "Not Done",
        skipped: "Skipped",
      },
      table: {
        name: "Name",
        selectAll: "Select All",
        selectRow: "Select Row",
        goingStatus: "Going Status",
        funnelState: "Funnel State",
        phoneNumber: "Phone Number",
        crmLink: "CRM Link",
        crmId: "CRM ID",
        status: "Status",
        profile: "Profile",
        dm: "Send DM",
        noStudents: "No students found",
        error: "Error loading students",
      },
      studentStatuses: {
        DONE: "Done",
        NOT_DONE: "Not Done",
        SKIPPED: "Skipped",
      },
      bulkActions: {
        DONE: "Mark done",
        NOT_DONE: "Mark not done",
        SKIPPED: "Mark skipped",
      },
      messages: {
        statusSuccess: "Success!",
        statusesSuccess: "Success!",
        statusUpdated: "You've updated the status for {{name}}",
        statusesUpdated: "You've updated the status for {{count}} students",
        error: "Something went wrong",
        statusError: "{{name}} failed to save. Please refresh or try again.",
        statusesError:
          "Failed to save status updates. Please refresh or try again.",
        close: "Close",
      },
      startBulkMessage: "Start Bulk Message",
    },
    table: {
      empty: {
        copy: "No items found. Get started now!",
        buttonCopy: "Add new item",
        title: "No items found",
      },
    },
  },
};
